import React from "react";
import ReactMarkdown from "react-markdown";

const C = {
  p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  strong: ({ children }) => <strong className="font-semibold text-tc-txt">{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
  ul: ({ children }) => <ul className="list-disc pl-5 mb-2 space-y-1">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal pl-5 mb-2 space-y-1">{children}</ol>,
  h1: ({ children }) => <div className="font-semibold text-tc-txt mb-1">{children}</div>,
  h2: ({ children }) => <div className="font-semibold text-tc-txt mb-1">{children}</div>,
  h3: ({ children }) => <div className="font-semibold text-tc-txt mb-1">{children}</div>,
  code: ({ children }) => <code className="font-mono text-[0.92em] bg-white/10 rounded px-1">{children}</code>,
  a: ({ children }) => <span className="underline">{children}</span>,
};

export const Markdown = ({ text, className = "", testid }) => (
  <div className={`break-words ${className}`} data-testid={testid}>
    <ReactMarkdown components={C}>{text || ""}</ReactMarkdown>
  </div>
);

export default Markdown;
